// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"default_footerContainer__DMl8J","footerSettings":"default_footerSettings__twom1"};